import React, { Component } from 'react';
import { Checkbox, Select } from '@shopify/polaris';
import { formatPricing } from 'src/helpers';

class ItemDetailPreview extends Component<ComposedProps, State> {
  render() {
    const { product, selectedProducts, updateSelectedProduct, tenantApp, page } = this.props;
    const CheckboxItem = (
      <React.Fragment>
        <Checkbox
          id={product.id}
          label=""
          onChange={() => {
            updateSelectedProduct(
              product.id,
              selectedProducts,
              !selectedProducts[product.id].selected
            );
          }}
          checked={
            selectedProducts[product.id] && selectedProducts[product.id].selected
              ? selectedProducts[product.id].selected
              : false
          }
        />
      </React.Fragment>
    );

    return (
      <React.Fragment>
        <div className="item-detail-preview">
          <div className="checkbox-container" style={{ display: 'block' }}>
            <div className="label-container" style={{ display: 'block' }}>
              <div
                className="label-wrapper"
                style={{
                  display: 'flex',
                  textAlign: page === 'search-page' ? 'center' : 'left',
                  wordBreak: 'break-word',
                  lineHeight: '1.2'
                }}>
                <span
                  style={{
                    cursor: 'pointer'
                  }}>
                  {product.title}
                </span>
              </div>

              {page === 'search-page' && (
                <div className="details-wrapper" style={{ display: 'block', marginTop: '5px' }}>
                  {product.variants && product.variants.length > 1 && (
                    <Select
                      label=""
                      options={product.variants.map(value => {
                        return { value: value, label: value.title };
                      })}
                      onChange={() => {}}
                      value={product.variants[0]}
                    />
                  )}
                </div>
              )}
              <div
                className="details-wrapper"
                style={{
                  justifyContent: page === 'search-page' ? 'center' : 'left',
                  marginTop: '5px'
                }}>
                <div style={{ display: 'flex' }}>
                  {page === 'search-page' && CheckboxItem}
                  <span className="item-detail-price">
                    {selectedProducts[product.id] &&
                      formatPricing(
                        selectedProducts[product.id].price,
                        tenantApp?.externalInfo?.money_in_emails_format
                      )}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
export default ItemDetailPreview;
